import React from 'react';
import { Card, Text, useMantineTheme, SimpleGrid } from '@mantine/core';

import { utils } from "../../utils/globalVariables";
import { getObjectParam2, stringDivider, sqlDateToHumanDate, safeValue } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";

const SerialNumberCheckerCard = ({ stateData, fnSelectedDataView }) => {

    const theme = useMantineTheme();

    return (
        <SimpleGrid
            cols={1}
            spacing='md'
            breakpoints={[
                { minWidth: 'xl', cols: 3, spacing: 'md' },
                { minWidth: 'lg', cols: 2, spacing: 'md' },
                { minWidth: 'md', cols: 2, spacing: 'md' },
                { minWidth: 'sm', cols: 2, spacing: 'md' },
                { minWidth: 'xs', cols: 2, spacing: 'md' },
            ]}
        >
            {Object.keys(stateData).map((key, index) => {
                return (
                    <Card
                        key={key}
                        shadow=''
                        radius="md"
                        withBorder={true}

                        style={{
                            borderColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[7],
                            backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
                            overflow: 'unset',
                            // cursor: 'pointer',
                        }}

                        onClick={() => {
                            fnSelectedDataView(stateData[key]);
                        }}
                    >
                        <Card.Section p='sm'>
                            <Text size="sm">
                                <LabelContentInline
                                    stateColLabel={4}
                                    stateLabel='Serial Number'
                                    stateContent={
                                        <Text sx={{ wordBreak: 'break-word' }}>
                                            {stateData[key].serial_number}
                                        </Text>
                                    }
                                    stateDivider={true}
                                />

                                <LabelContentInline
                                    stateColLabel={4}
                                    stateLabel='Posisi'
                                    stateContent={`${stateData[key].step ? (getObjectParam2(utils.projectProcess, stateData[key].step, 'caption', '') ? (getObjectParam2(utils.projectProcess, stateData[key].step, 'caption', '') + ' - ') : '') : ''} ${stateData[key].flag_modul}`}
                                    stateDivider={true}
                                />

                                <LabelContentInline
                                    stateColLabel={4}
                                    stateLabel='Tanggal Ambil'
                                    stateContent={sqlDateToHumanDate({
                                        stateDate: stateData[key].tanggal_ambil,
                                        stateWithTime: false,
                                        stateLang: 'id',
                                        stateIsShort: false,
                                        stateDay: false,
                                        stateDefaultValue: ' - ',
                                        stateDateType: 'day'
                                    })}
                                    stateDivider={true}
                                />

                                <LabelContentInline
                                    stateColLabel={4}
                                    stateLabel='Client'
                                    stateContent={safeValue(stateData[key].used_by_customer_name, ' - ')}
                                    stateDivider={true}
                                />

                                <LabelContentInline
                                    stateColLabel={4}
                                    stateLabel='No Nota'
                                    stateContent={stringDivider(stateData[key].project_id, [4, 6, 8], '.', ' - ')}
                                    stateDivider={false}
                                />
                            </Text>
                        </Card.Section>
                    </Card>
                )
            })}
        </SimpleGrid>
    )
}

export default React.memo(SerialNumberCheckerCard);